<div class="sms-limit">
    <!-- header -->
    <div class="sms-limit-header mb-0">
        <div class="ui-g-12 flex-between-center p-0">
            <div class="flex-start-center width-100p">
                <div class="width-100p p-relative font-600 font-16 mt-1">
                    SMS Credit Details
                </div>
            </div>
            <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose(false)"></i>
        </div>
    </div>

    <!-- body -->
    <div class="sms-limit-body flex-column">
        <div class="sms-credits-container">
            <div class="sms-credit-item">
                <div class="sms-credit-text">
                    <label>Free SMS Credits</label>
                    <p>Your CRM subscription includes 5,000 SMS credits per month. Unused credits expire at the end of
                        the month.</p>
                </div>
                <div class="sms-credit-value">
                    <button class="icon-button">+</button>
                    <span>{{smsDetails.monthlySubscription | number}}</span>
                </div>
            </div>

            <div class="sms-credit-item">
                <div class="sms-credit-text">
                    <label>Paid SMS Credits</label>
                    <p>Paid SMS credits do not expire. AutoLeap uses free SMS credits for campaigns before deducting paid SMS credits.</p>
                </div>
                <div class="sms-credit-value">
                    <button class="icon-button">=</button>
                    <span>{{smsDetails.purchasedSMS | number}}</span>
                </div>
            </div>

            <div class="sms-total-credits-container">
                <div class="sms-credits">
                    <span class="label">Total available SMS Credits
                        <i class="fal fa-info-circle text-dark font-16 font-secondary ml-2 mt-1"></i>
                    </span>
                    <span class="info-icon">
                    </span>
                    <span class="credits">
                        {{ smsDetails.purchasedSMS + smsDetails.monthlySubscription | number }}
                    </span>
                </div>
            </div>
        </div>

        <div class="sms-credits-footer pointer" (click)="buyMoreSMSCredits()">
            <button class="buy-credits">
                <i class="fal fa-coins font-primary-500 font-18 font-600 mr-2"></i>
                Buy SMS Credits
            </button>
        </div>


        <div *ngIf="isLoading" class="flex-center-center mb-0 p-2 font-14">
            <span>Loading</span>
            <i class="fal fa-spinner rotate ml-2"></i>
        </div>

        <div *ngIf="!isLoading">
            <div class="transaction-detail">
                Transaction History
            </div>

            <p-table class="sms-list" #dt [columns]="cols" [value]="smsCreditHistory" [lazy]="true" [scrollable]="true"
                [customSort]="true" [sortField]="'name'" [sortOrder]="1" (onLazyLoad)="customSort($event)">
                <ng-template pTemplate="header" let-columns>
                    <tr class="sms-list-grid-row-header">
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                            [ngStyle]="{ width: col.width, 'text-align': col.align }"
                            (click)="col.field !== 'coveredItemsCount' ? showSortIcon(col.field) : ''" class="font-600">
                            <span class="width-100p">
                                <p class="m-0">
                                    <span class="position-relative">
                                        <span>{{ col.header }}</span>
                                    </span>
                                </p>
                            </span>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr class="sms-list-grid-row" *ngIf="smsCreditHistory.length > 0">
                        <td *ngFor="let col of columns" [ngStyle]="{ width: col.width, 'text-align': col.align }">

                            <div class="width-100p" *ngIf="col.field === 'details'">
                                <div class="font-gray-35 font-14 font-400 text-truncate" tooltipPosition="top"
                                    [pTooltip]="rowData.details">
                                    {{ rowData[col.field] }}
                                </div>
                            </div>

                            <div class="width-100p" *ngIf="col.field !== 'details'">
                                <span
                                    [ngClass]="{'plus-transaction': rowData.status !== 'creditUsed', 'danger-transaction': rowData.status === 'creditUsed'}"
                                    *ngIf="col.field === 'transaction'">
                                    <i class="fal fa-plus" *ngIf="rowData.status !== 'creditUsed'"></i>
                                    <i class="fal fa-minus" *ngIf="rowData.status === 'creditUsed'"></i>
                                    {{ rowData[col.field] | number}}
                                </span>


                                <span class="font-600 font-14 font-black pr-1" *ngIf="col.field === 'monthlySMS'
                                || col.field === 'purchasedSMS'">
                                    {{ rowData[col.field] | number}}
                                </span>

                                <span class="capitalize font-gray-35 font-14 font-400"
                                    *ngIf="col.field !== 'transaction'
                                && col.field !== 'monthlySMS' && col.field !== 'purchasedSMS' && col.field !== 'details'">
                                    {{ rowData[col.field] }}
                                </span>
                            </div>


                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <!-- End Payment Table -->

            <div *ngIf="!isLoading && !smsCreditHistory?.length" class="ui-g-12 text-center not-found">
                <span class="font-gray-35 font-12 mt-2">Transactions will appear here once you purchase Paid SMS Credits or launch campaign.</span>
            </div>

            <p-paginator class="ui-g-12 p-0" [rows]="pageSize" [totalRecords]="totalRecords"
                (onPageChange)="paginate($event)">
            </p-paginator>
        </div>


    </div>
    <div class="sms-limit-footer border-top-lightest">

    </div>
</div>